import { FiscalpopCFDI } from '../../models/Factura';
import { endpoints } from './endpoints';
import { getAuthToken, request } from './http';

export interface CfdiCancelStatus {
    toCancelProcess: 'Cancelable sin aceptación' | 'Cancelable con aceptación' | 'No Cancelable';
    estado: boolean;
    cancelStatus: string;
}

export const cfdi = {
    findByDateRange(
        startMs: number,
        endMs: number,
        opts?: { conceptos?: boolean; impuestos?: boolean; signal?: AbortSignal }
    ): Promise<FiscalpopCFDI[]> {
        const { signal, ...flags } = opts ?? {};
        const qs = Object.entries(flags)
            .filter(([, v]) => v !== undefined)
            .map(([k, v]) => `${k}=${v}`)
            .join('&');
        return request<FiscalpopCFDI[]>(endpoints.cfdi.findBy(getAuthToken(), startMs, endMs, qs), {
            signal,
        });
    },
    findByUuid(uuid: string): Promise<FiscalpopCFDI[]> {
        return request<FiscalpopCFDI[]>(endpoints.cfdi.find(getAuthToken(), uuid));
    },
    getCancelStatus(uuid: string): Promise<CfdiCancelStatus> {
        return request<CfdiCancelStatus>(endpoints.cfdi.status(getAuthToken(), uuid));
    },
};
